import { SlingoHTMLHelpProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/SlingoHTMLHelpProperties";
export class GameHTMLHelpProperties extends SlingoHTMLHelpProperties {
    constructor() {
        super();
        this.extraSpinElements = ["help.slingo.standard.extraspins.line6"];
        this.availableWinElements = ["hitfor"];
    }
}
//# sourceMappingURL=GameHTMLHelpProperties.js.map